export default `#version 300 es
precision highp float;
#define GLSLIFY 1

uniform samplerCube tMap;
uniform float uCameraScale;

in vec3 vDir;
in float vFragDepth;

out vec4 fragData[2];

void main() {
    fragData[0] = texture(tMap, vDir);
    gl_FragDepth = log2(vFragDepth) / uCameraScale;
}`